import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import clienteAxios from '../../helpers/axios.helper';
import Swal from "sweetalert2"; // Importa SweetAlert2

function TablaCategorias() {
  const [categorias, setCategorias] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [filter, setFilter] = useState("Categoría");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const itemsPerPage = 15;
  const navigate = useNavigate();

  // Función para cargar categorías desde la API según el filtro
  const fetchCategorias = async (tipoCategoria) => {
    try {
      let url = "/categorias/";
      switch (tipoCategoria) {
        case "Categoría":
          url += "categoria1";
          break;
        case "Subcategoría":
          url += "categoria2";
          break;
        case "Tercera Categoría":
          url += "categoria3";
          break;
        default:
          return;
      }

      const response = await clienteAxios.get(url);
      setCategorias(response.data); // Aquí usamos response.data directamente
      setCurrentPage(0); // Reinicia la paginación
    } catch (error) {
      console.error("Error al cargar las categorías:", error);
    }
  };

  // Manejador para cambiar el filtro
  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setDropdownOpen(false);
    fetchCategorias(newFilter); // Llama a la API cuando cambie el filtro
  };

  // Calcula los elementos actuales para la paginación
  const offset = currentPage * itemsPerPage;
  const currentItems = categorias.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(categorias.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  // Carga inicial (trae las categorías 1 al cargar la página)
  useEffect(() => {
    fetchCategorias("Categoría");
  }, []);

  const handleRedirectAgregar = () => {
    navigate('/formulario-categoria')
  }

  const handleEditar = (categoria) => {
    navigate('/formulario-categoria', { state: { categoria, modoEdicion: true } });
  };

  const handleEliminar = async (categoriaId) => {
    // Reemplazar confirm con SweetAlert2
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: "Esta acción no se puede deshacer.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        // Mapeo para determinar el endpoint según el filtro
        const rutas = {
          "Categoría": "categoria1",
          "Subcategoría": "categoria2",
          "Tercera Categoría": "categoria3",
        };

        const tipoCategoria = rutas[filter]; // Obtén el tipo según el filtro
        if (!tipoCategoria) {
          console.error("Filtro inválido para eliminar:", filter);
          return;
        }

        const url = `/categorias/${tipoCategoria}/${categoriaId}`;
        await clienteAxios.delete(url);

        Swal.fire({
          title: 'Eliminado!',
          text: 'La categoría fue eliminada con éxito.',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        });

        fetchCategorias(filter); // Recarga las categorías después de eliminar
      } catch (error) {
        console.error("Error al eliminar la categoría:", error);
        Swal.fire({
          title: 'Error!',
          text: 'No se pudo eliminar la categoría.',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        });
      }
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg border-2 border-GrisOscuro w-full mx-auto">
      <div className="flex justify-end mb-4">
        <button onClick={handleRedirectAgregar} className="py-2 px-4 bg-Verde text-Blanco font-semibold rounded hover:bg-green-600">
          Agregar Categoría
        </button>
      </div>

      {/* Dropdown personalizado */}
      <div className="mb-4 relative w-1/3">
        <label className="mr-2">Filtrar por:</label>
        <div
          className="border border-Negro p-2 rounded cursor-pointer flex justify-between items-center"
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          {filter}
          {dropdownOpen ? <FaChevronDown /> : <FaChevronRight />}
        </div>
        {dropdownOpen && (
          <div className="absolute border mt-1 w-full bg-white rounded shadow-lg z-10">
            <div
              onClick={() => handleFilterChange("Categoría")}
              className="p-2 hover:bg-Verde border hover:border-Negro hover:font-semibold cursor-pointer"
            >
              Categorías
            </div>
            <div
              onClick={() => handleFilterChange("Subcategoría")}
              className="p-2 hover:bg-Verde border hover:border-Negro hover:font-semibold cursor-pointer"
            >
              Subcategorías
            </div>
            <div
              onClick={() => handleFilterChange("Tercera Categoría")}
              className="p-2 hover:bg-Verde border hover:border-Negro hover:font-semibold cursor-pointer"
            >
              Terceras Categorías
            </div>
          </div>
        )}
      </div>

      <table className="min-w-full bg-white border">
        <thead>
          <tr>
            <th className="text-start py-2 px-4 border-b">Nombre</th>
            {filter === "Tercera Categoría" && (
              <>
                <th className="text-start py-2 px-4 border-b">Subcategoría</th>
                <th className="text-start py-2 px-4 border-b">Categoría Principal</th>
              </>
            )}
            {filter === "Subcategoría" && (
              <th className="text-start py-2 px-4 border-b">Categoría Principal</th>
            )}
            <th className="text-start py-2 px-4 border-b">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((categoria) => (
            <tr key={categoria.id}>
              <td className="py-2 px-4 border-b">{categoria.nombre || categoria.Nombre}</td>
              {filter === "Tercera Categoría" && (
                <>
                  <td className="py-2 px-4 border-b">{categoria.categoria2Nombre || "-"}</td>
                  <td className="py-2 px-4 border-b">{categoria.categoria1Nombre || "-"}</td>
                </>
              )}
              {filter === "Subcategoría" && (
                <td className="py-2 px-4 border-b">{categoria.categoria1Nombre || "-"}</td>
              )}
              <td className="py-2 px-4 border-b">
                <div className="flex space-x-2">
                  <button onClick={() => handleEditar(categoria)} className="px-3 py-1 bg-Amarillo text-Blanco rounded border hover:bg-Blanco hover:text-Negro hover:border-Amarillo">
                    Editar
                  </button>
                  <button onClick={() => handleEliminar(categoria.id)} className="px-3 py-1 bg-Rojo text-Blanco rounded border hover:bg-Blanco hover:text-Negro hover:border-Rojo">
                    Eliminar
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex w-full flex-row h-20 justify-center items-end">
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          containerClassName="flex justify-center items-center"
          pageClassName="p-1 px-3 text-Negro bg-GrisClaro"
          activeClassName="bg-GrisOscuro text-Blanco"
          previousClassName="px-2 py-1 text-Rojo font-bold text-xl"
          nextClassName="px-2 py-1 text-Rojo font-bold text-xl"
          breakClassName="px-2 py-1 text-Rojo"
        />
      </div>
    </div>
  );
}

export default TablaCategorias;
